<template>
  <li
    class="navigation-list-language navigation-list-language--click"
    :class="{ 'navigation-list-language--open': isOpen }">
    <button
      type="button"
      class="navigation-list-language-item navigation-list-language-item--selected"
      :aria-label="$t(selectedLanguage.labelKey)"
      :aria-expanded="isOpen"
      aria-haspopup="listbox"
      data-testid="language-switcher"
      @click="onTriggerClick">
      <img
        :src="selectedLanguage.flag"
        :alt="$t(selectedLanguage.labelKey)"
        class="navigation-list-language-flag">
    </button>
    <div
      v-show="isOpen"
      class="navigation-list-language-menu"
      role="listbox"
      data-testid="language-menu">
      <button
        v-for="language in otherLanguages"
        :key="language.code"
        type="button"
        class="navigation-list-language-item"
        role="option"
        :aria-label="$t(language.labelKey)"
        data-testid="language-option"
        @click="onLanguageClick(language.code)">
        <img
          :src="language.flag"
          :alt="$t(language.labelKey)"
          class="navigation-list-language-flag">
      </button>
    </div>
  </li>
</template>

<script>
import { LANGUAGES } from '../config/languages'
import { setAppLanguage } from '../utils/setAppLanguage'

export default {
  name: 'LanguageSwitcher',
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.$store.state.language
    },
    selectedLanguage () {
      return LANGUAGES.find(language => language.code === this.selectedLanguageCode) || LANGUAGES[0]
    },
    otherLanguages () {
      return LANGUAGES.filter(language => language.code !== this.selectedLanguageCode)
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    handleDocumentClick (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    onTriggerClick () {
      this.isOpen = !this.isOpen
    },
    onLanguageClick (code) {
      setAppLanguage(this.$store, this.$i18n, code)
      this.isOpen = false
    }
  }
}
</script>
